import React from "react";

function HairIcon() {
  return (
    <path
      d="m 490.05889,286.89209 c 0,0 4.86678,99.88553 -17.47369,142.60897 0,0 -6.73444,-105.02167 -37.29994,-135.1023 -49.33216,2.9991 -117.17961,-2.98113 -172.04304,-45.27351 0,0 -2.78356,25.01626 45.36337,69.30207 0,0 -59.26329,6.57284 -112.88756,-72.10363 C 106.37421,266.43731 66.416383,366.53833 52.714007,412.35059 A 32.163786,32.163786 0 0 1 21.933029,435.30167 H 21.771392 C 9.2003937,330.72897 17.281752,249.12525 17.281752,249.12525 49.822664,100.48221 134.26381,118.74608 162.7461,129.64689 c 9.30253,-19.32339 32.03808,-38.70068 83.3457,-47.41059 0,0 108.25421,-63.160254 196.82584,20.09564 h -52.74431 c 0,0 111.72023,19.26953 111.72023,181.65085 0,0 -4.22027,1.25711 -11.83468,2.9093 z"
      style={{ fill: "#18181b" }}
    />
  );
}

export default HairIcon;
